<div class="d-flex gap-1">
  <app-icon-button [size]="'small'" [buttonIcon]="'profile'" [type]="'floating'"
    (clicked)="directToConsultaantProfile()"></app-icon-button>
  <app-icon-button [size]="'small'" [buttonIcon]="'suitcase'" [type]="'floating'"
    (clicked)="directToStakeholderList()"></app-icon-button>
  <app-icon-button [size]="'small'" [buttonIcon]="'task'" [type]="'floating'"
    (clicked)="directToTask()"></app-icon-button>
  <span class="contract-icon">
    <app-icon-button [size]="'small'" [buttonIcon]="'file'" [type]="'floating'"
      (clicked)="openContractModal()"></app-icon-button>
  </span>
</div>